$(function () {
    $(".features-toggle-collapse").hide();

    $(".features-toggle-collapse").click(function () {
        const expanded = $(this).hasClass("expanded") || false;

        $(".features .collapse").collapse(expanded ? "hide" : "show");
        $(this).toggleClass("expanded");
    });

    let body = $("body");

    if (body.hasClass('trucksales') || body.hasClass('caravancampingsales')) {
        const expanded = $(this).hasClass("expanded") || false;

        $(".features .collapse").collapse(expanded ? "hide" : "show");
        $(this).toggleClass("expanded");
    };

    $('.features a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
        const expandable = $(e.target).data("expandable") || false;

        $(".features-toggle-collapse").toggle(expandable);
    });


    if (window.featuresToInjectData) {
        var $featureToInject = $('#features-to-inject');
        for (var i = 0; i < featuresToInjectData.length; i++) {
            var item = featuresToInjectData[i];
            var $dom = $featureToInject.find('[data-index="' + i + '"]');
            var $target = $(item.target);
            if (!item.append) {
                $target.empty();
            }
            $target.append($dom.html());
        }
    }
});
